module.exports = __webpack_public_path__ + "static/media/05.eb988490.png";